import i18next from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const locales = {
  AU: 'en-GB',
  BR: 'pt-BR',
  CO: 'es-CO',
  DE: 'de-DE',
  ES: 'es-ES',
  IT: 'it-IT',
  UK: 'en-GB',
  US: 'en-US',
  ZA: 'en-ZA'
};

const mapRepubToLocale = repub => {
  return locales[repub] || 'en-GB';
};

const createI18nInstance = async repub => {
  try {
    const instance = i18next.createInstance();
    const endpoint = import.meta.env.VITE_CONTEXT_ENGINE_LABELS_ENDPOINT || '';
    await instance
      .use(initReactI18next)
      .use(HttpBackend)
      .init({
        supportedLngs: Array.from(new Set(Object.values(locales))),
        debug: false,
        lng: mapRepubToLocale(repub),
        fallbackLng: mapRepubToLocale(repub),
        ns: 'label',
        defaultNS: 'label',
        backend: {
          loadPath: `${endpoint}?locale={{lng}}&namespace={{ns}}`
        },
        react: {
          useSuspense: false
        },
        overloadTranslationOptionHandler: args => args
      });
    return instance;
  } catch (error) {
    return null;
  }
};

export default createI18nInstance;
